export default __webpack_public_path__ + "static/media/Gerrit_icon.824ebc7c.svg";